import { useTranslation } from '@/lib/i18n';
import type { AdminRole } from '../types/admin';

interface AdminRoleChipsProps {
  roles: ReadonlyArray<AdminRole>;
}

export const AdminRoleChips = ({ roles }: AdminRoleChipsProps) => {
  const { t } = useTranslation('common');
  if (roles.length === 0) return <span style={{ color: 'var(--content-muted)' }}>—</span>;
  return (
    <span className="flex flex-wrap gap-1">
      {roles.map((role) => (
        <span
          key={role}
          className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
          style={{
            background: 'var(--surface-1)',
            border: '1px solid var(--divider-strong)',
            color: 'var(--content-strong)',
          }}
        >
          {t(`admin.roles.codes.${role}`, role)}
        </span>
      ))}
    </span>
  );
};
